import moment from "imports/moment"
import daterangepicker from "imports/daterangepicker"
//import { gsap } from "imports/gsap";
//import { CSSRulePlugin } from "imports/gsap/CSSRulePlugin";
//gsap.registerPlugin(CSSRulePlugin);
let bookingWidget = {
    selHotelInput:'',
    selDiningInput:'',
    newTab:'',
    refactorIgnore:'',

    init: function () {
        let currentTab = $('#booking-widget').attr('data-active');
        $('#booking-widget').addClass('active-'+currentTab);

        //listeners
        $('#booking-widget .tabs .tab').on('click',bookingWidget.tabClick)
        bookingWidget.selDiningInput = $('#booking-widget .guests-input input')
        bookingWidget.selDiningInput.on('keydown',bookingWidget.diningInputDownListener)
        bookingWidget.selDiningInput.on('keyup',bookingWidget.diningInputValidateListener)

        $('#hotel-reserve-link').on('click',bookingWidget.hotelButtonClick)
        $('#dining-reserve-link').on('click',bookingWidget.diningButtonClick)


        //init
        bookingWidget.diningButtonActive()
        bookingWidget.hotelButtonActive()
        bookingWidget.initCalendars()

    },//init

    ///////////////////////////////////////////////////////////////////////////
    tabClick:function () {
        if (bookingWidget.newTab === '') {
            let clickedTab = $(this).attr('data-tab')
            bookingWidget.newTab = clickedTab
            bookingWidget.tabClickAnimateOut()
        }
    },
    tabClickAnimateOut:function () {
        let currentTab = $('#booking-widget').attr('data-active');
        let sectionSel = '#booking-widget .section.'+currentTab + ' .animated'
        let tl = gsap.timeline({onComplete: bookingWidget.tabClickAnimateIn})
        tl.fromTo(sectionSel, {y:0}, {duration: 0.15, y: -150, stagger:0.05, ease:Linear.easeNone})
    },
    tabClickAnimateIn:function () {
        $('#booking-widget').removeClass().addClass('active-' + bookingWidget.newTab).attr('data-active',bookingWidget.newTab)

        let sectionSel = '#booking-widget .section.'+bookingWidget.newTab + ' .animated'
        let tl = gsap.timeline({onComplete: bookingWidget.tabClickAnimateIn2})
        tl.fromTo(sectionSel, {y:150}, {duration: 0.2, y: 0, stagger:0.05, ease:Power3.easeOut})
    },
    tabClickAnimateIn2:function () {
        bookingWidget.newTab = ''
    },

    ///////////////////////////////////////////////////////////////////////////
    initCalendars:function() {
        $('#booking-widget .section .date-clicker').on('click',bookingWidget.dateClick)
        $('#booking-widget .section .date-clicker').on('change',bookingWidget.dateValueChanged)

        $('#booking-widget .date-picker').each(function( index ) {
            $(this).attr('type','text')
            let months = parseFloat($(this).attr('data-months'))
            let singleDate = false
            if (months !== 1 && months !== 2) {
                months = 2
            }
            if (months === 1) {
                singleDate = true
            }
            let tid = $(this).attr('id').toString()
            let useButton = ($(this).hasClass('generic-ajax-use-button')) ? "1" : ""

            let startDate = moment()
            let minDate = moment()
            if (tid==="booking-widget-hotel-end") {
                startDate = startDate.add(3, 'days')
            }

            let sel = $('#' + tid)
            sel.daterangepicker({
                autoUpdateInput:true,
                timePicker: false,
                autoApply:true,
                startDate: startDate,
                singleDatePicker:singleDate,
                minDate:minDate,
                locale: {
                    format: 'YYYY/MM/DD',
                    monthNames: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                },
            },null)
        });

        $('#booking-widget .section .date-clicker').change();

    },
    dateClick:function(event) {
        event.stopPropagation()
        let tid = $(this).attr('data-clicker-id')
        $('#'+tid).data("daterangepicker").show();
    },
    dateValueChanged:function(obj) {
        let p = $(this).parent()
        let dateValue = $('.date-picker',p).val()
        let dateMoment = moment(dateValue,'YYYY-MM-DD')
        let month = dateMoment.format("MMM");
        let date = dateMoment.format("D");
        let day = dateMoment.format("dddd");
        $('.month span',p).html(month)
        $('.date .num',p).html(date)
        $('.day span',p).html(day)

        //validate hotel & dining
        bookingWidget.hotelButtonActive()
        bookingWidget.diningButtonActive()
    },

    ///////////////////////////////////////////////////////////////////////////
    hotelButtonActive: function() {
        let startDate = moment($('#booking-widget-hotel-start').val(),'YYYY-MM-DD')
        let endDate = moment($('#booking-widget-hotel-end').val(),'YYYY-MM-DD')
        if (startDate.isSameOrAfter(endDate)) {
            $('#booking-widget .hotel-reserve').addClass('inactive')
        } else {
            $('#booking-widget .hotel-reserve').removeClass('inactive')
        }

        //set link
        startDate = startDate.format('MM-DD-YYYY')
        endDate = endDate.format('MM-DD-YYYY')
        //let link = 'https://reservations.circuscircus.com/room-search-results?propertyId=83010&guests=adultCount-2~kidCount-0&roomCount=1&promoCode=&accessibleRoom=false'
        let link = 'https://reservations.circuscircus.com/room-search-results?propertyId=83010'
        link += '&checkInDate='+startDate
        link += '&checkOutDate='+endDate
        $('#hotel-reserve-link').attr('href',link)
    },
    hotelButtonClick: function() {
        if ($('#booking-widget .hotel-reserve').hasClass('inactive')) {
            return false;
        } else {
            return true
        }
    },



    ///////////////////////////////////////////////////////////////////////////
    diningButtonActive: function() {
        let ret = bookingWidget.diningInputValidate()
        if (ret) {
            $('#booking-widget .guests-reserve').removeClass('inactive')
        } else {
            $('#booking-widget .guests-reserve').addClass('inactive')
        }

        //set link
        //https://urlgen.herokuapp.com/ - FYI url generator
        let startDate = moment($('#booking-widget-dining').val(),'YYYY-MM-DD')
        //startDate = startDate.format('MM-DD-YYYYThh:mm')
        startDate = startDate.format('YYYY-MM-DD') + "T19:00"
        const configRestref = $('#booking-widget .section.dining').attr('data-restaurant-opentable-id');
        const configNumGuests = parseFloat(bookingWidget.selDiningInput.val())
        let link = 'http://www.opentable.com/restaurant/profile/' + configRestref + '/reserve?'
        link += 'restref='+configRestref
        link += '&datetime='+startDate//2020-09-10T19:00
        link += '&covers='+configNumGuests
        link += '&searchdatetime='+startDate//2020-09-10T19:00
        link += '&partysize='+configNumGuests
        link += '&ot_source=Restaurant%20website'
        //link += '&ot_campaign=campaignid'
        //link += '&checkInDate='+startDate
        $('#dining-reserve-link').attr('href',link)
    },

    diningInputValidateListener:function () {
        let ret = bookingWidget.diningInputValidate()
        bookingWidget.diningButtonActive()
        return ret
    },
    diningInputDownListener:function(e) {
        switch (e.code) {
            case "Backspace":
            case "Delete":
            case "Shift":
            return true
            break
        }
        let val = parseFloat(e.key)
        return !isNaN(val)
    },

    diningInputValidate:function () {
        let ret = true
        let val = parseFloat(bookingWidget.selDiningInput.val())
        if ( isNaN(val) || val > 99 || val < 1) {
            ret = false
            bookingWidget.selDiningInput.val('')
        }
        return ret
    },
    diningButtonClick: function() {
        if ($('#booking-widget .guests-reserve').hasClass('inactive')) {
            return false;
        } else {
            return true
        }
    },

}
export default bookingWidget